'use client';

import { CaseStudyBody } from '@/components/case-study/case-study-body';
import { CaseStudyHero } from '@/components/case-study/case-study-hero';
import { useTranslation } from '@/lib/i18n/context';

/* HELD — not cleared for publication, and not routed.
 * Aqqo is at "Contacted" on the testimonial tracker with no reply on record,
 * so this sits under `_held/` until approval, like the stories in #200.
 *
 * Sourced from the implementation tracker (v1, Aug 8 2026 — day 27 of the
 * 30-day pilot). The migration figures are facts about the rollout, not
 * performance claims. The tracker states plainly that no live-traffic KPIs
 * exist yet; do not add an automation rate here until one does.
 *
 * FOLLOW-UP before this ships: /logos/logo-aqqo.svg does not exist yet (the
 * tracker flags the same gap), so the aside runs without a logo. */
const AqqoCaseStudy = () => {
  const { t } = useTranslation();
  return (
    <>
      <CaseStudyHero
        customerName="Aqqo"
        title={t.customerStories['aqqo_hero_title']}
        subtitle={t.customerStories['aqqo_what_we_did']}
      />

      <CaseStudyBody
        aside={{
          logoAlt: 'Aqqo',
          customerName: 'Aqqo',
          company: t.customerStories['aqqo_company_description'],
          industry: t.customerStories['aqqo_industry'],
          websiteUrl: 'https://www.aqqo.com',
          extras: [
            {
              label: t.customerStories.Location,
              value: t.customerStories['aqqo_location'],
            },
          ],
          keyResults: [
            t.customerStories['aqqo_key_result_1'],
            t.customerStories['aqqo_key_result_2'],
            t.customerStories['aqqo_key_result_3'],
            t.customerStories['aqqo_key_result_4'],
          ],
        }}
      >
        <p>{t.customerStories['aqqo_intro']}</p>

        <h2>{t.customerStories['aqqo_challenge_title']}</h2>
        <p>{t.customerStories['aqqo_challenge_p1']}</p>
        <p>{t.customerStories['aqqo_challenge_p2']}</p>
        <p>{t.customerStories['aqqo_challenge_p3']}</p>

        <h2>{t.customerStories['aqqo_solution_title']}</h2>
        <p>{t.customerStories['aqqo_solution_p1']}</p>
        <p>{t.customerStories['aqqo_solution_p2']}</p>
        <p>{t.customerStories['aqqo_solution_p3']}</p>
        <p>{t.customerStories['aqqo_solution_p4']}</p>

        <h2>{t.customerStories['aqqo_impact_title']}</h2>
        <p>{t.customerStories['aqqo_impact_p1']}</p>
        <p>{t.customerStories['aqqo_impact_p2']}</p>
      </CaseStudyBody>
    </>
  );
};

export default AqqoCaseStudy;
